import React from 'react';
import {Form, Badge, Button, Modal as Mod } from 'react-bootstrap';
import axios from 'axios';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';
import moment from 'moment';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Redirect } from "react-router-dom";
import { Spinner } from 'reactstrap';
import { CardBody, Fade } from 'reactstrap';
import ModalIngreso from './ModalIngreso';
import Cuestionario from './Cuestionario';
import ModalIngresoQR from './ModalIngresoQR';
import ModalIngresoQRAbierto from './ModalIngresoQRAbierto';

export default class Bandeja_entrada extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            posicion_tab: "1",
            idtbl_campo: 0,
            alertEnvioExitoso: false,
            rut: "",
            navigate: "",
            mostrarModalInformacion: false,
            isLoading: false,
            usuarioAutorizado: false,
            nombre: '',
            apellido: '',
            cargo: '',
            mostrarModal: false,
            mostrarNormal : false,
            mostrarModalEncuesta: false,
            empresa: '',
            pantete: '',
            temperatura: '',
            mascarilla: '',
            visita: '',
            num: '',
            observación: '',
            ingresos: [],
            fechaSalida: '',
            preguntaA: '',
            preguntaB: '',
            preguntaC: '',
            mostrarQR : false,
            preguntaD: '',
            sintomas: '',
            enfermedad: '',
            pais: '',
            Personas: []
        };
        this.validaLogin = this.validaLogin.bind(this);
        this.usoMascarilla = this.usoMascarilla.bind(this);
        this.buscarEncuestaManual = this.buscarEncuestaManual.bind(this);
        this.guardarFecha = this.guardarFecha.bind(this);
        this.marcarSalida = this.marcarSalida.bind(this);
        this.abrirEncuesta = this.abrirEncuesta.bind(this);
        this.onAfterSaveCell = this.onAfterSaveCell.bind(this);
        this.formatoh5 = this.formatoh5.bind(this);
        this.mostrarIngresoTarjetaYNormal = this.mostrarIngresoTarjetaYNormal.bind(this);
        this.btnNuevoIngreso = this.btnNuevoIngreso.bind(this);
        this.createCustomModalFooter = this.createCustomModalFooter.bind(this);
        this.createCustomModalBody = this.createCustomModalBody.bind(this);
        this.mostrarIngresoNormal = this.mostrarIngresoNormal.bind(this)
        this.guardarSalida = this.guardarSalida.bind(this);
        this.obtenerIngresosDiarios = this.obtenerIngresosDiarios.bind(this);
        this.onBeforeSaveCell = this.onBeforeSaveCell.bind(this);
        this.existeEncuesta = this.existeEncuesta.bind(this);
        this.formatotemperatura = this.formatotemperatura.bind(this);
        this.mostrarIngresoTarjeta = this.mostrarIngresoTarjeta.bind(this)
        this.mostrarIngresoTarjetaAbierto = this.mostrarIngresoTarjetaAbierto.bind(this)
        this.formatoEntrada = this.formatoEntrada.bind(this);
    }

    componentDidMount() {
        this.validaLogin()
    }

    validaLogin() {
        if (localStorage.getItem('idtbl_usuario') === undefined) {
            this.setState({ usuarioAutorizado: false });
        } else {
            this.setState({ usuarioAutorizado: true });
            this.obtenerIngresosDiarios();
        }
    }

    obtenerIngresosDiarios() {

        const obj = { fecha: moment().format("YYYY-MM-DD HH:mm:ss"), id_sucursal: localStorage.getItem("id_sucursal") };
        var optionAxios = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
        try {
            axios.post('https://accesos.sanjoseapps.cl/api/traerIngresosDiarios.php', obj, optionAxios).then(response => {
                const datos = response.data;
                if (datos !== undefined) {
                    this.setState({ ingresos: datos })
                };
            });
        } catch (error) {

        }
    }

    usoMascarilla(row) {
        let theButton;
        if (row === '0') {
            theButton = <Badge style={{ "color": "white", "padding": "0.9em 1.5em 0.9em 1.5em", "background-color": "#e89f4d" }} pill variant="danger"> <h5> NO </h5> </Badge>
        } else if (row === '1') {
            theButton = <Badge style={{ "color": "white", "padding": "0.9em 1.5em 1em 1.5em", "background-color": "#95b964" }} pill variant="success"> <h5> SI </h5> </Badge>
        }
        return theButton;
    }

    abrirEncuesta(row) {
        let valor = row;
        const obj = { id: valor };
        var optionAxios = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
        try {
            axios.post('https://accesos.sanjoseapps.cl/api/traerEncuesta.php', obj, optionAxios).then(response => {
                const datos = response.data;
                if (datos[0] !== undefined) {
                    this.setState({ preguntaA: datos[0].preguntaA })
                    this.setState({ preguntaB: datos[0].preguntaB })
                    this.setState({ preguntaC: datos[0].preguntaC })
                    this.setState({ preguntaD: datos[0].preguntaD })
                    this.setState({ preguntaF: datos[0].preguntaF })
                    this.setState({ enfermedad: datos[0].enfermedad })
                    this.setState({ pais: datos[0].pais })
                    this.setState({ sintoma: datos[0].sintoma })
                };
            });
        } catch (error) {

        }
        this.setState({ mostrarModalEncuesta: true });
    }

    buscarEncuestaManual(value) {
        for (var i in this.state.ingresos) {
            if (this.state.ingresos[i].id_encuesta === value) {
                return this.state.ingresos[i].manual;
            }

        }
    }

    existeEncuesta(row) {
        let valor = row
        let theButton;
        let manual = this.buscarEncuestaManual(valor)
        if (valor > 0) {
            if (manual !== "1") {
                theButton = <Button style={{ "width": "70%", "height": "80%" }} onClick={() => this.abrirEncuesta(row)}>VER </Button>
            } else {
                theButton = <Badge style={{ "color": "white", "padding": "0.8em 1.3em 1em 1.3em" }} pill variant="success"> <h6> ENCUESTA MANUAL </h6> </Badge>
            }
        } else {
            theButton = <Badge style={{ "color": "white", "padding": "0.8em 1.3em 1em 1.3em", "background-color": "#e89f4d" }} pill variant="success"> <h6> NO COMPLETADA </h6> </Badge>
        }
        return theButton;
    }

    guardarSalida(row) {
        let valor = row;
        const obj = { id: valor, fecha: moment().format("YYYY-MM-DD hh:mm:ss") };
        var optionAxios = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
        try {
            axios.post('https://accesos.sanjoseapps.cl/api/marcarSalida.php', obj, optionAxios).then(response => {
                const datos = response.data;
                if (datos !== undefined) {

                };
            });
        } catch (error) {
        }
        this.obtenerIngresosDiarios();
    }

    marcarSalida(row) {
        let valor = row;
        let disable = false
        this.state.ingresos.forEach(element => {
            if (element.id === row) {
                let fecha = element.fechaSalida;
                if (fecha !== '30-11--0001 00:00') {
                    disable = true;
                }
            }
        });
        let theButton;
        theButton = <Button style={{ "width": "90%", "height": "80%" }} disabled={disable} onClick={() => this.guardarSalida(valor)}  > SALIDA</Button>
        return theButton;
    }

    guardarFecha(row) {
        let theButton;
        if (row === '30-11--0001 00:00') {
            theButton = <Badge style={{ "color": "white", "padding": "0.7em 0.7em 0.7em 0.7em", "background-color": "#e89f4d" }} pill variant="danger">  <h6>  Sin salida marcada </h6>  </Badge>
        } else {
            theButton = <Badge style={{ "color": "white", "padding": "0.7em 0.7em 0.7em 0.7em" }} pill variant="success"> <h6> {row} </h6> </Badge>
        }
        return theButton;
    }

    formatoh5(row) {
        let columna;
        columna = <Badge> <h5> {row} </h5> </Badge>
        return columna;
    }

    formatoEntrada(row) {
        let columna;
        columna = <Badge> <h5> {row.format("YYYY-MM-DD HH:mm")} </h5> </Badge>
        return columna;
    }

    formatotemperatura(row) {
        let theButton;
        if (row > 38.5) {
            theButton = <Badge style={{ "color": "white", "padding": "0.9em 1.5em 0.9em 1.5em", "background-color": "#ce4552" }} pill variant="danger"> <h5> {"ALTA"}  </h5> </Badge>
        } else {
            theButton = <Badge style={{ "color": "white", "padding": "0.9em 1.5em 1em 1.5em", "background-color": "#95b964" }} pill variant="success"> <h5> {"NORMAL"}  </h5> </Badge>
        }
        return theButton;
    }

    onAfterSaveCell(row, cellName, cellValue) {
        var persona = row.persona.split(" ")
        var nombre = persona[0]
        var apellido = persona[1]
        const obj = { id: row.id, temperatura: row.temperatura, motivo: row.motivo, nombre: nombre, apellido: apellido, rut: row.rut, cargo: row.cargo, empresa: row.empresa, patente: row.patente, temperatura: row.temperatura, num_credencial: row.num, persona: row.persona, idtbl_usuario: localStorage.getItem('idtbl_usuario') }
        if (obj !== undefined) {
            axios.post('https://accesos.sanjoseapps.cl/api/actualizarIngreso.php', obj).then(response => {
                this.obtenerIngresosDiarios();
            });
        } else {
            alert("Ocurrio un error");
        }
    }

    onBeforeSaveCell(row, cellName, cellValue) {
        if (cellName === 'rut') {
            this.setState({ "rut": cellValue });
        }
        if (cellName === 'nombre') {
            this.setState({ "nombre": cellValue });
        }
        if (cellName === 'apellido') {
            this.setState({ "apellido": cellValue });
        }
        if (cellName === 'cargo') {
            this.setState({ "cargo": cellValue });
        }
        if (cellName === 'empresa') {
            this.setState({ "empresa": cellValue });
        }
        if (cellName === 'pantete') {
            this.setState({ "pantete": cellValue });
        }
        if (cellName === 'temperatura') {
            this.setState({ "temperatura": cellValue });
        }
        if (cellName === 'mascarilla') {
            this.setState({ "mascarilla": cellValue });
        }
        if (cellName === 'visita') {
            this.setState({ "visita": cellValue });
        }
        if (cellName === 'num') {
            this.setState({ "num": cellValue });
        }
        if (cellName === 'observación') {
            this.setState({ "observación": cellValue });
        }
        return true;
    }

    mostrarIngresoTarjeta() {
         this.setState({ mostrarQR: !this.state.mostrarQR })
        this.obtenerIngresosDiarios()
    }

    mostrarIngresoTarjetaAbierto(){
        this.setState({ mostrarNormalQRAbierto: !this.state.mostrarNormalQRAbierto })
       this.obtenerIngresosDiarios()
    }

    mostrarIngresoTarjetaYNormal() {
         this.setState({ mostrarQR: !this.state.mostrarQR })
         this.setState({  mostrarNormal : !this.state.mostrarNormal })
    }

     mostrarIngresoNormal() { this.setState({  mostrarNormal : !this.state.mostrarNormal })
         this.obtenerIngresosDiarios()
    }

    btnNuevoIngreso = (onClick) => {
        return (<div> <Button onClick={this.mostrarIngresoNormal} >Nuevo Ingreso</Button> <Button onClick={this.mostrarIngresoTarjeta}>Ingreso Tarjeta</Button> <Button onClick={this.mostrarIngresoTarjetaAbierto}>Ingreso Masivo Tarjeta </Button></div>);
    }

    createCustomModalBody = (columns, validateState, ignoreEditable) => {
        return (
            <ModalIngreso columns={columns}  validateState={validateState}  ignoreEditable={ignoreEditable} />
        );
    }

    createCustomModalHeader(onClose, onSave) {
        const headerStyle = {
            fontWeight: 'bold',
            fontSize: 'large',
            textAlign: 'center',
            backgroundColor: '#eeeeee'
        };
        return (
            <div className='modal-header' style={headerStyle}>
                <h3>Nuevo Ingreso</h3>
                <button className='btn btn-info' onClick={onClose}> X </button>
            </div>
        );
    }

    createCustomModalFooter = (onClose, onSave) => {
        const style = {
            backgroundColor: '#ffffff'
        };
        return (
            <div className='modal-footer' style={style}>
                <button className='btn btn-xs btn-info' onClick={onClose}>Cerrar</button>
                <button className='btn btn-xs tn-danger' onClick={onSave}> Confirmar </button>
            </div>
        );
    }

    render() {
        const options = {
            insertBtn: this.btnNuevoIngreso
            , insertModalBody: this.createCustomModalBody
            , insertModalHeader: this.createCustomModalHeader
            , insertModalFooter: this.createCustomModalFooter
        };
        const cellEditProp = {
            mode: 'click',
            blurToSave: true,
            beforeSaveCell: this.onBeforeSaveCell, // a hook for before saving cell
            afterSaveCell: this.onAfterSaveCell  // a hook for after saving cell
        };
        var login = localStorage.getItem('idtbl_usuario');
        if (login === null || login === "undefined") {
            return <Redirect to="/" push={true} />
        } else {
            return (
                <React.Fragment>
                    {this.state.isLoading === true ?
                        (<section className="table table-responsive mt-md-5">
                            <div className="container table">
                                <div align="center">
                                    <Spinner type="grow" color="success" /> </div>
                            </div>
                        </section>) : (
                            <Fade in={true} tag="h5" className="mt-3" transition={{ in: true, timeout: 750 }} >
                                <CardBody>
                                    {this.state.mostrarModalEncuesta === true ?
                                                  (  localStorage.getItem("id_sucursal") === "1" ?
                                                  <Mod show={this.state.mostrarModalEncuesta} onHide={() => this.setState({ mostrarModalEncuesta: false })} keyboard={false}>
                                                  <Mod.Header closeButton>
                                                      <Mod.Title>
                                                          <h5 style={{ "text-align": "right" }} className="bold-text">    {localStorage.getItem("id_sucursal") === "1" ? "Código: SGC-RG 8 POE 8" : "Código: SGSST-FOR-34  Versión: 02"}    </h5>
                                                          CUESTIONARIO INGRESO A PLANTA (CONTINGENCIA COVID-19)
                                                      </Mod.Title>
                                                  </Mod.Header>
                                                  <Mod.Body>
                                                      <div key={1} className="mb-3">
                                                          <p>
                                                              <h4>  A): ¿Presenta alguna enfermedad infectocontagiosa? Si es afirmativo, indique cuál:  &nbsp;&nbsp;
                                                                  {this.state.preguntaA === "1" ?
                                                                      <Form.Check label="SI" checked inline name="formHorizontalRadios" id="formHorizontalRadios1" disabled type="radio" />
                                                                      : <Form.Check label="NO" checked inline name="formHorizontalRadios" id="formHorizontalRadios1" disabled type="radio" />
                                                                  }
                                                                  <br></br>
                                                                  <Form.Control type="text" maxLength="250" field="rut" placeholder="DESCRIBIR ENFERMEDAD INFECTOCONTAGIOS" value={this.state.enfermedad} disabled ref={'rut'} />
                                                              </h4>
                                                          </p>
                                                      </div>
                                                      <br></br>
                                                      <div key={2} className="mb-3">
                                                          <p>
                                                              <h4>  B): ¿Ha estado en contacto con alguna persona que tenga sospecha o este contagiado con Covid-19?  &nbsp;&nbsp;
                                                                  {this.state.preguntaB === "1" ?
                                                                      <Form.Check label="SI" inline name="formHorizontalRadiosb" disabled checked id="formHorizontalRadios1" type="radio" />
                                                                      : <Form.Check label="NO" inline name="formHorizontalRadiosb" disabled checked id="formHorizontalRadios1" type="radio" />
                                                                  }
                                                              </h4>
                                                          </p>
                                                      </div>
                                                      <br></br>
                                                      <div key={3} className="mb-3">
                                                          <p>
                                                              <h4>   C): En las ultimas 2 semanas ¿Ha viajado fuera del pais?. Si su respuesta es afirmativa indique que pais:  &nbsp;&nbsp;
                                                                  {this.state.preguntaC === "1" ?
                                                                      <Form.Check label="SI" inline checked name="formHorizontalRadiosc" disabled id="formHorizontalRadios1" type="radio" />
                                                                      : <Form.Check label="NO" inline checked name="formHorizontalRadiosc" disabled id="formHorizontalRadios1" type="radio" />
                                                                  }
                                                                  <br></br>
                                                                  <Form.Control type="text" maxLength="50" field="rut" value={this.state.pais} placeholder="INDICAR PAIS" disabled ref={'rut'} />
                                                              </h4>
                                                          </p>
                                                      </div>
                                                      <br></br>
                                                      <div key={4} className="mb-3">
                                                          <p>
                                                              <h4> D): ¿Presenta ud., alguno de los siguientes sintomas: Tos seca, Fiebre sobre 38°C o secreción nazal?. Si es afirmativo indique cuál  &nbsp;&nbsp;
                                                                  {this.state.preguntaD === "1" ?
                                                                      <Form.Check label="SI" checked inline name="formHorizontalRadiosd" id="formHorizontalRadios1" disabled type="radio" />
                                                                      : <Form.Check label="NO" checked inline name="formHorizontalRadiosd" id="formHorizontalRadios1" disabled type="radio" />
                                                                  }
                                                                  <br></br>
                                                                  <Form.Control type="text" maxLength="250" placeholder="INDICAR SINTOMAS" value={this.state.sintoma} disabled={true} />
                                                              </h4>
                                                          </p>
                                                      </div>
                                                      <div key={5} className="mb-3">
                                                    <p>
                                                        <h4>j): ¿Su temperatura actual es igual o superior 37,5° C?  &nbsp;&nbsp;
                                                            <Form.Check label="SI" inline name="formHorizontalRadiosf" id="formHorizontalRadios5" onClick={() => this.handlePreguntaF(true)} type="radio" />
                                                            <Form.Check label="NO" inline name="formHorizontalRadiosf" id="formHorizontalRadios5" onClick={() => this.handlePreguntaF(false)}  type="radio" />
                                                            <br></br>
                                                        </h4>
                                                    </p>
                                                    En caso que alguna de sus respuestas sea SI, la empresa aplicará alguna medida preventiva tal como: Evaluar su ingreso.
                                                </div>
                                                </Mod.Body>
                                                    <Mod.Footer>
                                                        <Button variant="secondary" id="Cancelar" onClick={() => this.setState({ mostrarModalEncuesta: false })}>
                                                                Cancelar
                                                        </Button>
                                                    </Mod.Footer>
                                                </Mod>
                                                    :
                                                <Mod show={this.state.mostrarModalEncuesta} onHide={() => this.setState({ mostrarModalEncuesta: false })} keyboard={false}>
                                                   <Mod.Header closeButton>
                                                       <Mod.Title>
                                                           <h5 style={{ "text-align": "right" }} className="bold-text">    {localStorage.getItem("id_sucursal") === "1" ? "Código: SCG-RG 2 POE 8" : "Código: SGSST-FOR-34  Versión: 02"}    </h5>
                                                           CUESTIONARIO INGRESO A PLANTA (CONTINGENCIA COVID-19)
                                                       </Mod.Title>
                                                   </Mod.Header>
                                                <Mod.Body>
                                                       <div key={1} className="mb-3">
                                                           <p>
                                                               <h4>  A): ¿Presenta alguna enfermedad infectocontagiosa? Si es afirmativo, indique cuál  &nbsp;&nbsp;
                                                                   {this.state.preguntaA === "1" ?
                                                                       <Form.Check label="SI" checked inline name="formHorizontalRadios" id="formHorizontalRadios1" disabled type="radio" />
                                                                       : <Form.Check label="NO" checked inline name="formHorizontalRadios" id="formHorizontalRadios1" disabled type="radio" />
                                                                   }
                                                                   <br></br>
                                                                   <Form.Control type="text" maxLength="250" field="rut" placeholder="DESCRIBIR ENFERMEDAD INFECTOCONTAGIOS" value={this.state.enfermedad} disabled ref={'rut'} />
                                                               </h4>
                                                           </p>
                                                       </div>
                                                       <br></br>
                                                       <div key={2} className="mb-3">
                                                           <p>
                                                               <h4>  B): ¿Ha estado en contacto con alguna persona que tenga sospecha o este contagiado con Covid-19?  &nbsp;&nbsp;
                                                                   {this.state.preguntaB === "1" ?
                                                                       <Form.Check label="SI" inline name="formHorizontalRadiosb" disabled checked id="formHorizontalRadios1" type="radio" />
                                                                       : <Form.Check label="NO" inline name="formHorizontalRadiosb" disabled checked id="formHorizontalRadios1" type="radio" />
                                                                   }
                                                               </h4>
                                                           </p>
                                                       </div>
                                                       <br></br>
                                                       <div key={3} className="mb-3">
                                                           <p>
                                                               <h4>   C): En las ultimas 2 semanas ¿Ha viajado fuera del pais?. Si su respuesta es afirmativa indique que pais:  &nbsp;&nbsp;
                                                                   {this.state.preguntaC === "1" ?
                                                                       <Form.Check label="SI" inline checked name="formHorizontalRadiosc" disabled id="formHorizontalRadios1" type="radio" />
                                                                       : <Form.Check label="NO" inline checked name="formHorizontalRadiosc" disabled id="formHorizontalRadios1" type="radio" />
                                                                   }
                                                                   <br></br>
                                                                   <Form.Control type="text" maxLength="50" field="rut" value={this.state.pais} placeholder="INDICAR PAIS" disabled ref={'rut'} />
                                                               </h4>
                                                           </p>
                                                       </div>
                                                       <br></br>
                                                       <div key={4} className="mb-3">
                                                           <p>
                                                               <h4> D): ¿Presenta ud., alguno de los siguientes sintomas: Tos seca, Fiebre sobre 38°C o secreción nazal?. Si es afirmativo indique cuál  &nbsp;&nbsp;
                                                                   {this.state.preguntaD === "1" ?
                                                                       <Form.Check label="SI" checked inline name="formHorizontalRadiosd" id="formHorizontalRadios1" disabled type="radio" />
                                                                       : <Form.Check label="NO" checked inline name="formHorizontalRadiosd" id="formHorizontalRadios1" disabled type="radio" />
                                                                   }
                                                                   <br></br>
                                                                   <Form.Control type="text" maxLength="250" placeholder="INDICAR SINTOMAS" value={this.state.sintoma} disabled={true} />
                                                               </h4>
                                                           </p>
                                                       </div>
                                                   </Mod.Body>
                                                   <Mod.Footer>
                                                       <Button variant="secondary" id="Cancelar" onClick={() => this.setState({ mostrarModalEncuesta: false })}>
                                                           Cancelar
                                                       </Button>
                                                   </Mod.Footer>
                                               </Mod>
                                                     )   : ""
                                        }
                                        {this.state.mostrarQR === true ?
                                             <Mod show={this.state.mostrarQR} onHide={() => this.setState({ mostrarQR: false })} backdrop="static" keyboard={false}>
                                             <Mod.Header closeButton>
                                               <Mod.Title> INGRESAR A PLANTA </Mod.Title>
                                             </Mod.Header>
                                             <Mod.Body>
                                                     <ModalIngresoQR  cerraryMostrar = {this.mostrarIngresoTarjetaYNormal} mostrarModal = {this.mostrarIngresoTarjeta}> </ModalIngresoQR>
                                             </Mod.Body>
                                             <Mod.Footer>
                                               <Button variant="secondary" id="Cancelar" onClick={() => this.setState({ mostrarQR: false })}>
                                                 Cancelar
                                               </Button>
                                             </Mod.Footer>
                                           </Mod> : ""
                                        }
                                        {this.state.mostrarNormal === true ?
                                             <Mod show={this.state.mostrarNormal} onHide={() => this.setState({ mostrarNormal: false })} backdrop="static" keyboard={false}>
                                             <Mod.Header closeButton>
                                               <Mod.Title> INGRESAR A PLANTA </Mod.Title>
                                             </Mod.Header>
                                             <Mod.Body>
                                                     <ModalIngreso  mostrarModal = {this.mostrarIngresoNormal} > </ModalIngreso>
                                             </Mod.Body>
                                             <Mod.Footer>
                                               <Button variant="secondary" id="Cancelar" onClick={() => this.setState({ mostrarNormal: false })}>
                                                 Cancelar
                                               </Button>
                                             </Mod.Footer>
                                           </Mod> : ""
                                        }
                                        {this.state.mostrarNormalQRAbierto === true ?
                                             <Mod show={this.state.mostrarNormalQRAbierto} onHide={() => this.setState({ mostrarNormalQRAbierto: false })} backdrop="static" keyboard={false}>
                                             <Mod.Header closeButton>
                                               <Mod.Title> INGRESAR A PLANTA </Mod.Title>
                                             </Mod.Header>
                                             <Mod.Body>
                                                     <ModalIngresoQRAbierto  mostrarModal = {this.mostrarIngresoTarjetaAbierto} > </ModalIngresoQRAbierto>
                                             </Mod.Body>
                                             <Mod.Footer>
                                               <Button variant="secondary" id="Cancelar" onClick={() => this.setState({ mostrarNormalQRAbierto: false })}>
                                                 Cancelar
                                               </Button>
                                             </Mod.Footer>
                                           </Mod> : ""
                                        }
                                    <div className="form__form-group" style={{ "container": "wrap" }} >
                                        <div className="table" style={{ "margin": "auto", "fontSize": "0.7rem" }} >
                                            <BootstrapTable scrollTop={'Bottom'} wrapperClasses="table-responsive"  data={this.state.ingresos} insertRow cellEdit={cellEditProp} options={options} search={true} searchPlaceholder={"Texto para búsqueda..."} hover pagination >
                                                <TableHeaderColumn width='90' isKey dataField='id' hiddenOnInsert hidden={true} >ID</TableHeaderColumn>
                                                <TableHeaderColumn width='130' dataFormat={this.formatoh5} dataSort={true} editable={false} dataField='fecha' > <h5> ENTRADA </h5> </TableHeaderColumn>
                                                <TableHeaderColumn width='100' dataFormat={this.formatoh5} dataSort={true} editable={false} dataField='rut' > <h5> RUT  </h5> </TableHeaderColumn>
                                                <TableHeaderColumn width='120' dataFormat={this.formatoh5} dataSort={true} editable={true} dataField='persona'> <h5> NOMBRE </h5></TableHeaderColumn>
                                                {localStorage.getItem('temperatura') === "true" ?
                                                    <TableHeaderColumn width='110' dataFormat={this.formatotemperatura} dataSort={true} dataField='temperatura'> <h5> TEMPERATURA </h5> </TableHeaderColumn>
                                                    :
                                                    <TableHeaderColumn width='110' dataFormat={this.formatotemperatura} dataSort={true} dataField='temperatura' hidden={true} > <h5> TEMPERATURA </h5> </TableHeaderColumn>
                                                }
                                                {localStorage.getItem('mascarilla') === "true" ?
                                                    <TableHeaderColumn width='120' dataSort={true} dataField='mascarilla' dataFormat={this.usoMascarilla} > <h5> USO MASCARILLA</h5> </TableHeaderColumn>
                                                    :
                                                    <TableHeaderColumn width='120' dataField='mascarilla' dataFormat={this.usoMascarilla} hidden={true}  > <h5> USO MASCARILLA</h5> </TableHeaderColumn>
                                                }
                                                <TableHeaderColumn width='120' editable={false} dataField='id_encuesta' dataFormat={this.existeEncuesta} hiddenOnInsert > <h5> ENCUESTA </h5> </TableHeaderColumn>
                                                {localStorage.getItem('cargo') === "true" ?
                                                    <TableHeaderColumn width='120' dataFormat={this.formatoh5} editable={true} dataField='cargo' > <h5> CARGO </h5> </TableHeaderColumn>
                                                    :
                                                    <TableHeaderColumn width='120' dataFormat={this.formatoh5} dataField='cargo' hidden={true}   > <h5> CARGO </h5> </TableHeaderColumn>
                                                }
                                                {localStorage.getItem('empresa') === "true" ?
                                                    <TableHeaderColumn width='120' dataFormat={this.formatoh5} editable dataField='empresa'> <h5> EMPRESA </h5> </TableHeaderColumn>
                                                    :
                                                    <TableHeaderColumn width='120' dataFormat={this.formatoh5} dataField='empresa' hidden={true}  > <h5> EMPRESA </h5> </TableHeaderColumn>
                                                }
                                                {localStorage.getItem('visita') === "true" ?
                                                    <TableHeaderColumn width='100' dataField='visita' dataSort={true} dataFormat={this.usoMascarilla} > <h5> VISITA </h5> </TableHeaderColumn>
                                                    :
                                                    <TableHeaderColumn width='100' dataField='visita' dataFormat={this.usoMascarilla} hidden={true}  > <h5> VISITA </h5> </TableHeaderColumn>
                                                }
                                                {localStorage.getItem('visita') === "true" ?
                                                    <TableHeaderColumn width='150' dataFormat={this.formatoh5} editable dataField='num' > <h5> NUMERO CREDENCIAL </h5> </TableHeaderColumn>
                                                    :
                                                    <TableHeaderColumn width='150' dataFormat={this.formatoh5} dataField='num' hidden={true}  > <h5> NUMERO CREDENCIAL </h5> </TableHeaderColumn>
                                                }
                                                {(localStorage.getItem('patente') === "true") ?
                                                    <TableHeaderColumn width='100' dataFormat={this.formatoh5} editable dataField='patente'  > <h5> PATENTE </h5> </TableHeaderColumn>
                                                    :
                                                    <TableHeaderColumn width='100' dataFormat={this.formatoh5} dataField='patente' hidden={true} > <h5> PATENTE </h5> </TableHeaderColumn>
                                                }
                                                {localStorage.getItem('observacion') === "true" ?
                                                    <TableHeaderColumn width='120' dataFormat={this.formatoh5} editable dataField='observación' hidden={true} > <h5> OBSERVACIÓN </h5>  </TableHeaderColumn>
                                                    :
                                                    <TableHeaderColumn width='120' dataFormat={this.formatoh5} dataField='observación' hidden={true}  >  <h5> OBSERVACIÓN </h5>  </TableHeaderColumn>
                                                }
                                                {localStorage.getItem('motivo') === "true" ?
                                                    <TableHeaderColumn width='120' dataFormat={this.formatoh5} dataField='motivo'> <h5> MOTIVO </h5>  </TableHeaderColumn>
                                                    :
                                                    <TableHeaderColumn width='120' dataFormat={this.formatoh5} dataField='motivo' hidden={true} >  <h5> MOTIVO </h5>  </TableHeaderColumn>
                                                }
                                                <TableHeaderColumn width='120' editable={false} dataSort={true} dataField='fechaSalida' dataFormat={this.guardarFecha} hiddenOnInsert >  <h5> SALIDA </h5> </TableHeaderColumn>
                                                <TableHeaderColumn width='120' editable={false} dataField='id' dataFormat={this.marcarSalida} hiddenOnInsert > <h5> MARCAR SALIDA </h5> </TableHeaderColumn>
                                            </BootstrapTable>
                                        </div>
                                    </div>
                                </CardBody>
                            </Fade>
                        )
                    }
                </React.Fragment >
            )
        }
    }
}
